export default __webpack_public_path__ + "static/media/CoinOneKahshCard.d2818fa8.png";